<form-layout
    [showSave]="false"
    (onSave)="onSaveClick()"
    (onBack)="onBackClick()"
    (onNext)="onSaveAndNextClick()">
    
    <schedule-data [form]="scheduleDataProcessStepForm" [grid]="gridView" [currentPhase]="this.anfrage.phase" [currentReportId]="this.reportId" (saveEvent)="saveEvent()"></schedule-data>
</form-layout>
